/**
 * SEO and meta tag utilities
 */

export interface SEOMetaTags {
  title: string
  description: string
  image?: string
  url?: string
  type?: string
}

/**
 * Generate SEO meta tags for a public profile
 */
export function generateProfileMetaTags(profile: {
  firstName: string
  lastName: string
  title?: string
  bio?: string
  profilePhoto?: string
  username: string
}): SEOMetaTags {
  const fullName = `${profile.firstName} ${profile.lastName}`
  const title = profile.title
    ? `${fullName} - ${profile.title}`
    : `${fullName} - Portfolio`

  const description =
    profile.bio ||
    `View ${fullName}'s professional profile, experience, skills, and more.`

  const url =
    typeof window !== 'undefined'
      ? `${window.location.origin}/profile/${profile.username}`
      : undefined

  return {
    title,
    description,
    image: profile.profilePhoto,
    url,
    type: 'profile',
  }
}

/**
 * Truncate text for meta descriptions
 */
export function truncateDescription(text: string, maxLength = 160): string {
  if (text.length <= maxLength) return text
  return text.substring(0, maxLength - 3) + '...'
}
